import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styles from './CheckCard.module.css';

interface CheckCardProps {
  titleKey: string;
  descriptionKey: string;
  timeKey: string;
  imageUrl: string;
  onStart: () => void;
}

const CheckCard: React.FC<CheckCardProps> = ({
  titleKey,
  descriptionKey,
  timeKey,
  imageUrl,
  onStart,
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  const getButtonText = () => {
    return location.pathname === '/check' ? 'start_test_button' : 'start_session_button';
  };

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <div className={styles.imageFrame}>
          <img
            src={imageUrl}
            alt={t(titleKey)}
            className={styles.media}
          />
        </div>
      </div>
      <div className={styles.contentContainer}>
        <h3 className={styles.title}>{t(titleKey)}</h3>
        <p className={styles.description}>{t(descriptionKey)}</p>
        <span className={styles.timeEstimate}>{t(timeKey)}</span>
      </div>
      <div className={styles.footer}>
        <button className={styles.startButton} onClick={onStart}>
          <span>{t(getButtonText())}</span>
          <svg className={styles.startIcon} viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5 0C6.49187 0 0 6.49187 0 14.5C0 22.5081 6.49187 29 14.5 29C22.5081 29 29 22.5081 29 14.5C29 6.49187 22.5081 0 14.5 0ZM19.7031 14.9594L12.0781 20.3469C12.0271 20.3839 11.9686 20.4093 11.9067 20.4212C11.8448 20.4331 11.781 20.4312 11.7199 20.4156C11.6589 20.4 11.602 20.3711 11.5534 20.3308C11.5048 20.2905 11.4657 20.24 11.4387 20.1831C11.4117 20.1263 11.3975 20.0644 11.3969 20.0016V8.99844C11.3975 8.93566 11.4117 8.87375 11.4387 8.81691C11.4657 8.76006 11.5048 8.70951 11.5534 8.66924C11.602 8.62897 11.6589 8.60001 11.7199 8.58441C11.781 8.56881 11.8448 8.56694 11.9067 8.57884C11.9686 8.59075 12.0271 8.61613 12.0781 8.65312L19.7031 14.0406C19.7477 14.0715 19.7842 14.1123 19.8099 14.1597C19.8356 14.2072 19.8498 14.2601 19.8513 14.3141C19.8528 14.3681 19.8416 14.4217 19.8186 14.4706C19.7956 14.5195 19.7614 14.5624 19.7187 14.5958L19.7031 14.9594Z" fill="white"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CheckCard; 